import * as PmxApi from 'privmx-server-api';
import { BaseApi } from './BaseApi';

export class CaptchaApi extends BaseApi implements PmxApi.api.captcha.ICaptchaApi {
    createCaptcha(): Promise<PmxApi.api.captcha.CaptchaChallenge> {
        return this.request('captcha.createCaptcha', {});
    }
}
